// extracted by mini-css-extract-plugin
export default {"root":"IconButton_root__80xkD","average":"IconButton_average__7WiEO","small":"IconButton_small__wsMp9"};